import { Alert, Container, Typography } from '@mui/material';
import React, { useState } from 'react';
import ReportFilterBuilder from '../components/reports/ReportFilterBuilder';
import ReportResultsTable from '../components/reports/ReportResultsTable';
import reportsService from '../services/reports-service';

export default function ReportsPage() {
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [reportConfig, setReportConfig] = useState(null);

  const handleGenerateReport = async (config) => {
    setLoading(true);
    setError(null);
    setReportConfig(config);

    try {
      const response = await reportsService.generateReport(config);

      if (response.success) {
        setReportData(response.data || []);
      } else {
        setError(response.message || 'Failed to generate report');
        setReportData([]);
      }
    } catch (err) {
      console.error('Error generating report:', err);
      setError('An error occurred while generating the report');
      setReportData([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="xl" sx={{ mt: 8, mb: 4 }}>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 600, mb: 3 }}>
        Reports Generator
      </Typography>

      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Generate custom reports by selecting a table, applying filters, and
        choosing a date range.
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError(null)}>
          {error}
        </Alert>
      )}

      <ReportFilterBuilder onGenerateReport={handleGenerateReport} />

      <ReportResultsTable
        data={reportData}
        loading={loading}
        reportConfig={reportConfig}
      />
    </Container>
  );
}
